import { createTheme } from '@mui/material/styles';

const theme = createTheme({
  palette: {
    primary: { main: '#4f227d', light: '#7b4da8', dark: '#371755', contrastText: '#fff' },
    secondary: { main: '#ffe200', light: '#ffeb3d', dark: '#e6cb00', contrastText: '#1a1a1a' },
    background: { default: '#f8f6fa', paper: '#ffffff' },
  },
  typography: {
    fontFamily: '"Inter", "Segoe UI", "Roboto", sans-serif',
    h4: { fontWeight: 700 },
    h5: { fontWeight: 600 },
    h6: { fontWeight: 600 },
  },
  shape: { borderRadius: 12 },
  components: {
    MuiPaper: { styleOverrides: { root: { borderRadius: 12, boxShadow: '0 2px 12px rgba(79, 34, 125, 0.08)' } } },
    MuiChip: { styleOverrides: { root: { borderRadius: 8 } } },
  },
});

export default theme;
